import { default as _91_46_46_46slug_93p3kiOQzcRSMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/[...slug].vue?macro=true";
import { default as index2hfoHX92dKMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/auth/index.vue?macro=true";
import { default as indexNko0HhFDU4Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as datenschutzHOKzwrhHCUMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/datenschutz.vue?macro=true";
import { default as datenverarbeitung9dJLab2yqYMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/datenverarbeitung.vue?macro=true";
import { default as _91id_93YWFHJGvCa4Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93ShkodINrR1Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/formProcess/success/[id].vue?macro=true";
import { default as impressumBIW87DncArMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/impressum.vue?macro=true";
import { default as indexUiyucSidprMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/index.vue?macro=true";
import { default as _91slug_93idSFhKHH78Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/news/[slug].vue?macro=true";
import { default as organisationsxyqDDQmUMXMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/organisations.vue?macro=true";
import { default as indexjy8gXw1mH5Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/processes/index.vue?macro=true";
import { default as dungeonwmU80YTrgeMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputslxbp1k1WM6Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexlZr7ZyMlNIMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index.vue?macro=true";
import { default as indexfn5MxQrSbvMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataw4xJNU0pxIMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassy1jJhlqX22Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93jMGPWnqTFYMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexytyL5ml9GmMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataDEHGtpP3H2Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramReportsA9Tbn1RbNVMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsyFXjX0HniTMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_938gYOsC6kRuMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexfjR3GBpNaiMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesWCfubRFL2yMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatawI2wK9rjHRMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93dJRzxalhCmMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexiqyZ5bbc9bMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesgZXF8WSJNyMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataZ12CzlBBuyMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93y2nkidsDMsMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as index3PhRcDoLfwMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDatan6gotFHsL4Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93HnxvcxAg2JMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexzr9PfesuLcMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statusActivitiesQ494egcaQAMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataLUfI83Cxg6Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsVTMSvPhdk2Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93mhTKhxmUbUMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexE4CUXdZYFaMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDatamTcGFCCW8xMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataDg4QKcQrfKMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as yearInterviewsssaSAQohoqMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearInterviews.vue?macro=true";
import { default as _91id_93Aw8Gwn5vH2Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexECRchLyAzlMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataO6A2Jm1MwZMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93gylsDEutsOMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexbpirmdcWrzMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/index.vue?macro=true";
import { default as paymentRunActivitiespTetIqcDg4Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue?macro=true";
import { default as paymentRunBaseDatal8kQPInvsLMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsgXC6LDeeMZMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93QYBgF6xAQeMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexodEriaFCpnMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsQl4RbKbl37Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesyxDfVtVrzmMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataNacQxiqcItMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93EKxrXS4xsaMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id].vue?macro=true";
import { default as indextpl9pkCcycMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalAmEp5g7teaMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93JuHpOqgqseMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexVbET8slu0iMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersUP9UDXJz4AMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivities6a3aFeK1RwMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingst74JsfT4iEMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatassY2JcifOPMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesL3hQsNi9KZMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptKPeyxolbuHMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheetpRP5sxrTfLMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUserszikWXkrwCsMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93ag4iAQ8bD6Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexJO8UniFFxlMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsp6hQc3seNYMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivities0StpihUwY7Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatadwUBxQEfpeMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFilters1Hdv5s7ffeMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignaturegqUoFqkk5RMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93FF6joG7IwNMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexbisKXlw77YMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/index.vue?macro=true";
import { default as users8OY04SVo2ZMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users.vue?macro=true";
import { default as settingsOv3t0MtNj2Meta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings.vue?macro=true";
import { default as servicedrfvdiLaTqMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service.vue?macro=true";
import { default as indexGZcfMJEhadMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/childOrganisations/index.vue?macro=true";
import { default as language33afHitk6tMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseData6CdMwocykSMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesbziTyGVCEUMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationProtectionConceptpTaYQn61BIMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue?macro=true";
import { default as organisationStemSheet046X6fpS0yMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationStemSheet.vue?macro=true";
import { default as organisationUsersM3NrUm8DQfMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_930IvwrOEwltMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataB17uu1UHuNMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureK6KA1z7DxnMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93qADDCWKo7nMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id].vue?macro=true";
import { default as settingsJfEUd4ph6sMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings.vue?macro=true";
import { default as signatureDCrJ5b1sOHMeta } from "/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/signature.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93p3kiOQzcRSMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index2hfoHX92dKMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexNko0HhFDU4Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/datenschutz.vue")
  },
  {
    name: "datenverarbeitung",
    path: "/datenverarbeitung",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/datenverarbeitung.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93YWFHJGvCa4Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93ShkodINrR1Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexUiyucSidprMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsxyqDDQmUMXMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexjy8gXw1mH5Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/processes/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicedrfvdiLaTqMeta?.name,
    path: "/service",
    meta: servicedrfvdiLaTqMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataO6A2Jm1MwZMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexfn5MxQrSbvMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93jMGPWnqTFYMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexytyL5ml9GmMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_938gYOsC6kRuMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexfjR3GBpNaiMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93dJRzxalhCmMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexiqyZ5bbc9bMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93y2nkidsDMsMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: index3PhRcDoLfwMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93HnxvcxAg2JMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexzr9PfesuLcMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93mhTKhxmUbUMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsVTMSvPhdk2Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexE4CUXdZYFaMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93Aw8Gwn5vH2Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearData.vue")
  },
  {
    name: "service-basicData-years-id-yearInterviews",
    path: "yearInterviews",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/[id]/yearInterviews.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexECRchLyAzlMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93gylsDEutsOMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/index.vue")
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsQl4RbKbl37Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93QYBgF6xAQeMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunActivities",
    path: "paymentRunActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunActivities.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexodEriaFCpnMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93EKxrXS4xsaMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indextpl9pkCcycMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalAmEp5g7teaMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsOv3t0MtNj2Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersUP9UDXJz4AMeta?.name,
    path: "loginProviders",
    meta: loginProvidersUP9UDXJz4AMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93JuHpOqgqseMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexVbET8slu0iMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsp6hQc3seNYMeta?.name,
    path: "organisations",
    meta: organisationsp6hQc3seNYMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93ag4iAQ8bD6Meta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexJO8UniFFxlMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: users8OY04SVo2ZMeta?.name,
    path: "users",
    meta: users8OY04SVo2ZMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93FF6joG7IwNMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexbisKXlw77YMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsJfEUd4ph6sMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings.vue"),
    children: [
  {
    name: "settings-childOrganisations",
    path: "childOrganisations",
    meta: indexGZcfMJEhadMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/childOrganisations/index.vue")
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_930IvwrOEwltMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationProtectionConcept",
    path: "organisationProtectionConcept",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationProtectionConcept.vue")
  },
  {
    name: "settings-organisations-id-organisationStemSheet",
    path: "organisationStemSheet",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationStemSheet.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93qADDCWKo7nMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureDCrJ5b1sOHMeta || {},
    component: () => import("/home/forge/develop.oase-aej.de/releases/20261104073704/client/pages/signature.vue")
  }
]